import { ChartDataResponse, MetricInfo, campaignMetrics, MetricLabels } from "@api/common";
import { AppState, currentReportCampaign } from "@store";
import { FetchingState } from "rd-redux-http";
import * as React from "react";
import { connect } from "react-redux";
import { Paginator, PaginatorData } from "./Paginator/Paginator";
import { ReportLabel } from "./ReportLabel";
import "./ReportMetricsPerDateTable.css";
import { formatNumber } from "@common";

interface ReportMetricsPerDateTableProps {
    data: ChartDataResponse;
    metrics: MetricInfo[];
}

class ReportMetricsPerDateTableComponent extends React.Component<ReportMetricsPerDateTableProps> {
    constructor(props: ReportMetricsPerDateTableProps) {
        super(props);
    }
    render() {
        const { data, metrics } = this.props;
        return (
            <div className="ReportMetricsPerDateTable">
                <ReportLabel title={"Performance"} />
                <Paginator data={ReportMetricsPerDateTableComponentTransformer(data, metrics)} />
            </div>
        );
    }
}

export const ReportMetricsPerDateTable = connect((state: AppState) => {
    const campaign = currentReportCampaign(state);
    const metrics = campaignMetrics(campaign ? campaign.unit : "CPM");

    return {
        data: FetchingState.getDataOrDefault(state.reports.chartData.dateData, {
            metrics: [],
            dimensions: []
        }),
        metrics
    };
})(ReportMetricsPerDateTableComponent);

function ReportMetricsPerDateTableComponentTransformer(data: ChartDataResponse, metrics: MetricInfo[]): PaginatorData {
    const flatData = data.metrics
        .map(m =>
            m.data.map(i => ({
                metric: m.metric,
                date: i["dimension-values"][0],
                value: i["metric-value"]
            }))
        )
        .reduce((result, arr) => [...result, ...arr], []);

    const result: PaginatorData = {
        headerData: ["Date", ...metrics.map(MetricLabels.tableColumnHeader)]
    };

    const valuesHash = flatData.reduce((result, item) => {
        result[item.date] = result[item.date] || {};
        result[item.date][item.metric] = item.value;

        return result;
    }, {});

    result.contentData = Object.keys(valuesHash)
        .sort((a, b) => (a === b ? 0 : a > b ? 1 : -1))
        .map(date => {
            const values = valuesHash[date];

            return [
                date,
                ...metrics.map(m => {
                    const value = values[m.metric] || 0;

                    return m.isRate ? `${(value * 100).toFixed(2)}%` : formatNumber(value);
                })
            ];
        });

    return result;
}
